export const KIOSKO_CONTENT = {
    lessons: {
        // kiosko.vender — «Vender en el kiosko» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "contable.pos" — práctica: sí
        "kiosko.vender": {
            summary: "Cómo se arma y se cobra una venta del kiosko desde Kiosko → Vender, que es la misma pantalla que la tablet del mostrador. Aprendés qué medios se aceptan, por qué la venta no existe hasta que el cobro está confirmado y por qué el kiosko va separado de la cuota y de la caja del gimnasio. Cada venta queda atada a la sede, a quien vendió y al medio de pago; la de efectivo, además, a la caja del kiosko. El stock se descuenta solo.",
            keyPoints: [
                "Antes de vender, fijate que la sede activa sea la tuya: si no tenés una sede con kiosko elegida, Vender te pide elegirla ahí mismo.",
                "El kiosko tiene su propia caja, aparte de la del gimnasio, y es sólo efectivo: se abre con el fondo contado al empezar el turno y se cierra contando al terminarlo. El estado (abierta desde qué hora y por quién) se ve arriba de Vender y en Caja → Kiosko.",
                "Sin la caja del kiosko abierta, Efectivo queda apagado y aparece Abrir caja del kiosko. Con MP Point o QR se puede vender igual: esa plata no pasa por ninguna caja de efectivo.",
                "En Productos aparecen sólo los que tienen stock en la sede, y no podés sumar más unidades de las que hay. El importe final sale del precio del catálogo al cobrar.",
                "Asociar un socio es opcional y nunca frena la fila: sin socio queda como venta de mostrador.",
                "Medios: efectivo (entra a la caja del kiosko, nunca a la del gimnasio), MP Point (el importe viaja solo al dispositivo) y QR de Mercado Pago. El posnet Payway no está disponible desde el kiosko. Lo electrónico se factura solo; el efectivo, sólo si lo piden.",
                "Sin pago confirmado no hay venta: no hay fiado ni «lo pago con la cuota», que va por Cobrar en mostrador. Si Mercado Pago deja el cobro pendiente, la venta no se cierra y el stock no se mueve. Si ARCA no contesta, el cobro queda igual y el comprobante sale después.",
                "Anular es sólo del día y con motivo escrito, y lo hacen encargado, Administración o dueños: el stock vuelve a entrar y, si estaba facturada, sale la nota de crédito.",
            ],
            estimatedMin: 8,
            contentVersion: 3,
        },
        // kiosko.ventas — «Ventas del día y anulaciones» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "kiosko.ventas" — práctica: no
        "kiosko.ventas": {
            summary: "Dónde se consultan las ventas del kiosko (las del mostrador y las de la tablet pública) y cómo se corrige una venta mal hecha. Aprendés por qué una venta nunca se borra: se anula, con motivo y con alguien que lo autoriza, y el sistema deshace cada cosa que la venta había movido. Así el historial cuenta lo que pasó, incluidos los errores.",
            keyPoints: [
                "En Kiosko → Ventas filtrás por fecha, sede (si no elegís, la activa), medio y canal (mostrador o tablet pública). El detalle muestra productos, estado, medio, canal, comprobante y, si fue por QR, la orden y el pago de Mercado Pago.",
                "«Cobrado en el período» no incluye las anuladas; «Ventas» las cuenta todas, marcadas. Por eso pueden no coincidir, y está bien.",
                "Si una venta vieja dice «ver cobro» en el medio, es que el dato no se guardó acá: el sistema no inventa un medio, el dato está en el cobro.",
                "Las anulaciones no se hacen desde el listado: se hacen en Vender, tabla Ventas de hoy. Sólo lo del día, con un motivo de al menos cinco letras, y las hacen encargado, Administración o dueños; a recepción el botón no le aparece.",
                "Al anular se hace el contra-asiento del cobro por el mismo medio, el stock vuelve a entrar y, si estaba facturada, sale la nota de crédito. La venta no se borra: queda Anulada con fecha y motivo, y los dueños reciben una alerta.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // kiosko.stock — «Stock y conteo» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "contable.stock" — práctica: sí
        "kiosko.stock": {
            summary: "Cómo se controla la mercadería del kiosko en cada sede: el stock que dice el sistema, el conteo físico que carga recepción, las mermas y los lotes por vencer. Aprendés por qué un conteo con diferencias no corrige el stock solo y quién aprueba ese ajuste.",
            keyPoints: [
                "El stock es de cada sede y no existe pasar mercadería de una sede a otra: cada sede compra lo suyo. Entra por compra y sale por venta, merma o ajuste, y cada movimiento queda con cantidad, motivo y quién lo hizo.",
                "Tres indicadores: productos que perforan el mínimo, lotes por vencer y conteos esperando ajuste. Si alguno no está en cero, hay algo para mirar.",
                "El conteo físico lo carga recepción sin ver cuánto debería haber, para que sea honesto; el sistema calcula la diferencia línea por línea.",
                "La diferencia no ajusta nada sola: el stock sigue igual hasta que control de stock aprueba el ajuste con motivo, o desestima el conteo (también con motivo) si estuvo mal hecho. Sin ese permiso, ves la diferencia pero no la cerrás.",
                "La merma (rotura, vencido, pérdida) se registra siempre con motivo y queda auditada. Lo que «queda» de cada lote por vencer es una estimación; un lote vencido se da de baja como merma.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // kiosko.productos — «Productos y precios del kiosko» — roles: admin (Administración), owner (Dueño) — pantalla: "contable.productos" — práctica: no
        "kiosko.productos": {
            summary: "Cómo se mantiene el catálogo del kiosko: alta de productos con foto, categoría, precio y control de vencimiento, cambio de precio y stock mínimo por sede. Aprendés por qué el precio es uno solo para las tres sedes, qué pasa con las ventas pasadas cuando lo cambiás y por qué un producto se da de baja en vez de borrarse.",
            keyPoints: [
                "El precio de venta es único para las tres sedes: no existe precio por sede. Lo editan Administración y los dueños; recepción y encargados no editan el catálogo.",
                "Al cambiar un precio escribís siempre el motivo: queda en la auditoría junto con el precio anterior, y el cambio no reescribe las ventas pasadas.",
                "Un producto nuevo no tiene stock: la mercadería entra cuando se registra una compra, y hasta entonces no aparece para vender. Si nunca se compró no tiene costo, y sin costo no se calcula el margen.",
                "Si el producto se vence, activás Controla vencimiento: al ingresar mercadería se pide la fecha del lote y el sistema avisa antes de que venza.",
                "El stock mínimo se fija por sede; cuando el stock lo perfora, control de stock recibe el aviso para reponer.",
                "Nada se borra: un producto que deja de venderse se da de baja apagando Activo, sale de la venta y de la tablet, y la historia queda.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // kiosko.tablets — «Las tablets públicas: qué ve el socio y cómo se configuran» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "kiosko.tablets" — práctica: no
        "kiosko.tablets": {
            summary: "La tablet pública es una tienda del kiosko que se deja abierta en la sede para que el socio elija, pague solo con el QR de Mercado Pago y retire sin hacer fila. Aprendés cómo se crea y se da de baja el link de cada tablet, qué ve el socio y dónde se ven esas ventas.",
            keyPoints: [
                "Cada link es de una sede: la tablet muestra el catálogo y el stock de esa sede, y no ofrece lo que no hay. Lo crean encargados, coordinación, Administración o dueños; el encargado sólo ve sus sedes y recepción no crea links.",
                "Para cobrar hace falta la cuenta de Mercado Pago del kiosko, que vincula el dueño desde Integraciones; sin ella la tienda abre pero no cobra, y la pantalla lo avisa.",
                "El link se abre en la tablet escaneando su QR o con Copiar link. La tienda no muestra ningún dato de socios ni del equipo.",
                "El socio paga sólo con el QR de Mercado Pago: la venta existe recién cuando Mercado Pago confirma. Si se vence el tiempo o cancela, no se cobró nada.",
                "Si la tablet se pierde o se cambia, el link se da de baja con motivo y deja de mostrar la tienda en el acto; las ventas ya hechas no se tocan.",
                "Todas sus ventas se ven en Kiosko → Ventas con el canal «Tablet pública».",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
    },
    questions: [
        // ── kiosko.vender ───────────────────────────────────────────────────────
        {
            id: "kiosko.vender#1",
            lessonKey: "kiosko.vender",
            prompt: "Llegás a la recepción, entrás a Kiosko → Vender y Efectivo está apagado, con la caja del kiosko «Cerrada». Un socio quiere pagar un agua en efectivo. ¿Qué hacés?",
            options: [
                { id: "a", text: "Lo cobrás en Caja del turno, en la caja del gimnasio." },
                { id: "b", text: "Abrís la caja del kiosko con el fondo contado y cobrás en efectivo." },
                { id: "c", text: "Le decís que hoy el kiosko no vende." },
                { id: "d", text: "Lo cobrás con QR y le das el vuelto de tu bolsillo." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el efectivo del kiosko va a su propia caja: tocás Abrir caja del kiosko, cargás el fondo contado y Efectivo se habilita. Con Mercado Pago se podía vender aunque estuviera cerrada.",
        },
        {
            id: "kiosko.vender#2",
            lessonKey: "kiosko.vender",
            prompt: "Un socio quiere llevarse una isotónica y que se la sumes a la cuota del mes. ¿Qué hacés?",
            options: [
                { id: "a", text: "La sumás al ticket y la dejás pendiente hasta que pague la cuota." },
                { id: "b", text: "Lo asociás como socio y la venta queda en su cuenta." },
                {
                    id: "c",
                    text: "Le explicás que se cobra al entregar: la cuota va aparte.",
                },
                { id: "d", text: "La cobrás junto con la cuota desde Vender." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, no hay fiado ni «lo pago con la cuota»: la venta se cobra al entregar, y la cuota va por Cobrar en mostrador, nunca desde el kiosko.",
        },
        {
            id: "kiosko.vender#3",
            lessonKey: "kiosko.vender",
            prompt: "Cobraste con QR de Mercado Pago y el pago quedó pendiente. ¿Qué pasa con la venta y el stock?",
            options: [
                { id: "a", text: "No se cierra ni mueve stock: esperás y volvés a cobrar." },
                { id: "b", text: "La venta queda registrada y el stock se descuenta igual." },
                { id: "c", text: "Se cobra solo en efectivo para no perder la venta." },
                { id: "d", text: "La venta se cierra y el pago se concilia al día siguiente." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, sin pago confirmado no hay venta. Si Mercado Pago deja el cobro pendiente, la venta no se cierra y el stock no se mueve: esperás la confirmación en el dispositivo y volvés a cobrar.",
        },
        {
            id: "kiosko.vender#4",
            lessonKey: "kiosko.vender",
            prompt: "Un cliente paga en efectivo una barrita y no pide factura. ¿Se emite comprobante?",
            options: [
                { id: "a", text: "Sí, siempre: toda venta genera su factura sola." },
                { id: "b", text: "Sí, una factura A a nombre del club." },
                { id: "c", text: "No, y además el efectivo del kiosko no entra a la caja." },
                { id: "d", text: "No: el efectivo se factura sólo si lo piden." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, los pagos electrónicos generan su comprobante solos, pero el efectivo se factura sólo si lo piden: tildás Pedir factura y elegís B, o A con el CUIT.",
        },
        // ── kiosko.ventas ───────────────────────────────────────────────────────
        {
            id: "kiosko.ventas#1",
            lessonKey: "kiosko.ventas",
            prompt: "En Kiosko → Ventas, «Ventas» dice 52 y «Cobrado en el período» suma menos que esas 52 ventas. ¿Por qué puede pasar?",
            options: [
                {
                    id: "a",
                    text: "Porque «Ventas» también cuenta las anuladas.",
                },
                { id: "b", text: "Porque lo cobrado sólo suma el efectivo." },
                { id: "c", text: "Porque hay un error y hay que avisar a Administración." },
                { id: "d", text: "Porque lo cobrado sólo incluye las ventas de la tablet." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, «Cobrado en el período» suma sólo lo cobrado: una venta anulada no es venta. «Ventas» las cuenta todas, también las anuladas. Por eso pueden no coincidir, y está bien.",
        },
        {
            id: "kiosko.ventas#2",
            lessonKey: "kiosko.ventas",
            prompt: "Sos recepcionista y te diste cuenta de que cobraste dos veces el agua a un socio hace una hora. ¿Qué hacés?",
            options: [
                { id: "a", text: "La anulás vos desde Kiosko → Ventas." },
                { id: "b", text: "Le devolvés la plata de la caja y no registrás nada." },
                {
                    id: "c",
                    text: "Llamás al encargado: anular no te corresponde.",
                },
                { id: "d", text: "Esperás al cierre de caja para que figure como diferencia." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, las anulaciones se hacen en Vender, tabla Ventas de hoy, con motivo. Las hacen encargado, Administración o dueños: si sos recepción el botón no te aparece, así que llamás al encargado.",
        },
        {
            id: "kiosko.ventas#3",
            lessonKey: "kiosko.ventas",
            prompt: "Se anula una venta facturada que se había pagado con MP Point. ¿Qué pasa?",
            options: [
                { id: "a", text: "Se borra del historial y el stock no cambia." },
                {
                    id: "b",
                    text: "Contra-asiento por el mismo medio, vuelve el stock y sale la nota de crédito.",
                },
                { id: "c", text: "Se devuelve en efectivo de la caja del turno y se edita la venta a $ 0 para que no sume." },
                { id: "d", text: "Se anula la factura pero la venta sigue como cobrada." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, al anular se hace el contra-asiento del cobro por el mismo medio, el stock vuelve a entrar y, si estaba facturada, sale la nota de crédito. La venta no se borra: queda Anulada con la fecha y el motivo.",
        },
        {
            id: "kiosko.ventas#4",
            lessonKey: "kiosko.ventas",
            prompt: "En una venta vieja, la columna del medio dice «ver cobro». ¿Qué significa?",
            options: [
                { id: "a", text: "Que se cobró en efectivo." },
                { id: "b", text: "Que la venta no se cobró y quedó pendiente hasta que alguien registre el pago." },
                { id: "c", text: "Que la venta fue anulada." },
                { id: "d", text: "Que el medio no se guardó en la venta: el dato está en el cobro." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, «ver cobro» aparece cuando el medio no se guardó en la venta: el sistema no inventa un medio, y el dato está en el cobro.",
        },
        // ── kiosko.stock ────────────────────────────────────────────────────────
        {
            id: "kiosko.stock#1",
            lessonKey: "kiosko.stock",
            prompt: "Cargaste el conteo físico y faltan 3 aguas respecto de lo que esperaba el sistema. ¿Qué pasa con el stock?",
            options: [
                { id: "a", text: "Se ajusta solo a lo que contaste." },
                {
                    id: "b",
                    text: "Sigue igual hasta que control de stock decida, con motivo.",
                },
                { id: "c", text: "Se descuenta como merma automáticamente." },
                { id: "d", text: "Se descuenta el faltante y se carga como diferencia al turno de caja abierto." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el conteo no ajusta nada solo: el stock teórico sigue igual y la diferencia espera a control de stock, que aprueba el ajuste o lo desestima, siempre con motivo.",
        },
        {
            id: "kiosko.stock#2",
            lessonKey: "kiosko.stock",
            prompt: "Mientras cargás el conteo físico, no ves cuántas unidades debería haber de cada producto. ¿Por qué?",
            options: [
                { id: "a", text: "Porque es un error de la pantalla y hay que avisar." },
                { id: "b", text: "Porque recepción no tiene permiso para ver el stock." },
                { id: "c", text: "Para que el conteo sea honesto." },
                { id: "d", text: "Porque el esperado se carga después, a mano." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, al contar no ves cuánto debería haber: así el conteo es honesto. La diferencia la calcula el sistema después, línea por línea.",
        },
        {
            id: "kiosko.stock#3",
            lessonKey: "kiosko.stock",
            prompt: "A Olivos le sobran barritas y a otra sede le faltan. ¿Se pueden pasar de una sede a la otra en el sistema?",
            options: [
                { id: "a", text: "No: cada sede compra lo suyo." },
                { id: "b", text: "Sí, con una merma en Olivos y un ajuste en la otra sede." },
                { id: "c", text: "Sí, desde Stock y conteo con el botón Transferir." },
                { id: "d", text: "Sí, si lo aprueba control de stock." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, no existe pasar mercadería de una sede a otra: cada sede compra lo suyo, y el stock nunca se mezcla.",
        },
        {
            id: "kiosko.stock#4",
            lessonKey: "kiosko.stock",
            prompt: "Se rompió el envoltorio de dos barritas y no se pueden vender. ¿Cómo lo registrás?",
            options: [
                { id: "a", text: "Las sacás de la heladera y lo corregís en el próximo conteo." },
                { id: "b", text: "Las vendés a $ 0 desde el kiosko." },
                { id: "c", text: "Pedís un ajuste a control de stock sin motivo." },
                { id: "d", text: "Registrás una Merma de 2 unidades con su motivo." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si algo se rompió, venció o se perdió, se registra una merma con su motivo: baja el stock y queda auditado. No se baja stock sin motivo.",
        },
        // ── kiosko.productos ────────────────────────────────────────────────────
        {
            id: "kiosko.productos#1",
            lessonKey: "kiosko.productos",
            prompt: "En una sede quieren vender la isotónica más cara que en las otras. ¿Cómo se hace?",
            options: [
                { id: "a", text: "Se edita el precio sólo para esa sede." },
                { id: "b", text: "No se puede: el precio es único para las tres sedes." },
                { id: "c", text: "Se crea otro producto igual con otro precio para esa sede." },
                { id: "d", text: "Recepción lo cambia al cobrar." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el catálogo es el mismo para las tres sedes: no hay precio distinto por sede, el campo no existe.",
        },
        {
            id: "kiosko.productos#2",
            lessonKey: "kiosko.productos",
            prompt: "Subís el precio de la isotónica por un aumento del proveedor. ¿Qué pasa con las ventas que ya se hicieron?",
            options: [
                { id: "a", text: "Se recalculan con el precio nuevo." },
                { id: "b", text: "Quedan pendientes de revisión hasta que se apruebe el precio." },
                {
                    id: "c",
                    text: "No se tocan: el cambio queda auditado.",
                },
                { id: "d", text: "Se anulan y se vuelven a cargar." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, un cambio de precio no toca las ventas ya hechas, y queda en la auditoría junto con el precio anterior. Por eso conviene escribir siempre el motivo.",
        },
        {
            id: "kiosko.productos#3",
            lessonKey: "kiosko.productos",
            prompt: "Diste de alta un producto nuevo y no aparece para vender en el kiosko. ¿Por qué?",
            options: [
                { id: "a", text: "Porque todavía no tiene stock: entra con una compra." },
                { id: "b", text: "Porque falta cargarle el código de barras." },
                { id: "c", text: "Porque hay que esperar al día siguiente." },
                { id: "d", text: "Porque recepción tiene que activarlo en su sede antes de poder venderlo." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, un producto nuevo no tiene stock: entra cuando se registra una compra. Hasta entonces dice «no está en esta sede» y no aparece para vender.",
        },
        {
            id: "kiosko.productos#4",
            lessonKey: "kiosko.productos",
            prompt: "Una barrita deja de venderse en el club. ¿Qué hacés con el producto?",
            options: [
                { id: "a", text: "Lo borrás del catálogo." },
                { id: "b", text: "Le ponés precio $ 0." },
                { id: "c", text: "Le ponés stock mínimo cero en todas las sedes para que deje de reponerse." },
                { id: "d", text: "Apagás Activo: sale de la venta y la historia queda." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, nada se borra: un producto que deja de venderse se da de baja apagando Activo, sale de la venta y de la tablet, y su historia queda.",
        },
        // ── kiosko.tablets ──────────────────────────────────────────────────────
        {
            id: "kiosko.tablets#1",
            lessonKey: "kiosko.tablets",
            prompt: "Configuraste la tablet y aparece un aviso de que falta vincular la cuenta de Mercado Pago del kiosko. ¿Qué pasa?",
            options: [
                { id: "a", text: "La tienda no abre hasta que se vincule." },
                { id: "b", text: "La tienda abre y cobra en efectivo en recepción mientras tanto." },
                {
                    id: "c",
                    text: "Abre pero no cobra; la cuenta la vincula el dueño.",
                },
                { id: "d", text: "La vinculás vos desde el link de la tablet." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, sin la cuenta de Mercado Pago vinculada la tienda abre pero no puede cobrar. La vincula el dueño desde Integraciones.",
        },
        {
            id: "kiosko.tablets#2",
            lessonKey: "kiosko.tablets",
            prompt: "Un socio armó su pedido en la tablet, apareció el QR y se le venció el tiempo sin pagar. ¿Qué pasó?",
            options: [
                { id: "a", text: "No se cobró nada: la pantalla lo avisa." },
                { id: "b", text: "La venta quedó registrada como pendiente de pago." },
                { id: "c", text: "Se le descontó el stock igual." },
                { id: "d", text: "Se le cobra en recepción la próxima vez que venga." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la venta existe recién cuando Mercado Pago confirma. Si se vence el tiempo o el socio cancela, la pantalla avisa que no se cobró nada.",
        },
        {
            id: "kiosko.tablets#3",
            lessonKey: "kiosko.tablets",
            prompt: "Se perdió la tablet de la entrada. ¿Qué hacés con su link?",
            options: [
                { id: "a", text: "Nada: sin la tablet nadie puede usar el link, y las ventas quedan registradas igual." },
                { id: "b", text: "Lo das de baja con motivo: la tienda deja de mostrarse en el acto." },
                { id: "c", text: "Lo borrás junto con sus ventas." },
                { id: "d", text: "Cambiás la sede del link a otra." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, si la tablet se pierde o se cambia, tocás Dar de baja con motivo: la tablet deja de mostrar la tienda en el acto y las ventas ya hechas no se tocan.",
        },
        {
            id: "kiosko.tablets#4",
            lessonKey: "kiosko.tablets",
            prompt: "Querés ver cuánto vendió la tablet de Olivos esta semana. ¿Dónde lo mirás?",
            options: [
                { id: "a", text: "En Tablets públicas, dentro del link." },
                { id: "b", text: "En la cuenta de Mercado Pago, porque esas ventas no se registran en el sistema." },
                { id: "c", text: "En el cierre de caja del turno." },
                { id: "d", text: "En Kiosko → Ventas, filtrando el canal «Tablet pública»." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, cada venta de la tablet queda registrada igual que en el mostrador, y todas se ven en Kiosko → Ventas con el canal «Tablet pública».",
        },
    ],
};
//# sourceMappingURL=kiosko.js.map